module.exports = __webpack_public_path__ + "static/media/Wolverine.fd17e9e7.png";